import { render, staticRenderFns } from "./ReservationListItem.vue?vue&type=template&id=630c9c01&scoped=true&lang=pug"
import script from "./ReservationListItem.vue?vue&type=script&lang=js"
export * from "./ReservationListItem.vue?vue&type=script&lang=js"
import style0 from "./ReservationListItem.vue?vue&type=style&index=0&id=630c9c01&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "630c9c01",
  null
  
)

export default component.exports